import { render, staticRenderFns } from "./Expired_product.vue?vue&type=template&id=81adccae&scoped=true&"
import script from "./Expired_product.vue?vue&type=script&lang=js&"
export * from "./Expired_product.vue?vue&type=script&lang=js&"
import style0 from "./Expired_product.vue?vue&type=style&index=0&id=81adccae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81adccae",
  null
  
)

export default component.exports